/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clipboard_Copy_ErrorInputs */

const es_clipboard_copy_error = /** @type {(inputs: Clipboard_Copy_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo copiar al portapapeles`)
};

const en_clipboard_copy_error = /** @type {(inputs: Clipboard_Copy_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy to clipboard`)
};

/**
* | output |
* | --- |
* | "Failed to copy to clipboard" |
*
* @param {Clipboard_Copy_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const clipboard_copy_error = /** @type {((inputs?: Clipboard_Copy_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clipboard_Copy_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_clipboard_copy_error(inputs)
	return en_clipboard_copy_error(inputs)
});
export { clipboard_copy_error as "clipboard.copy_error" }